import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import Fade from '@mui/material/Fade';
import styles from './Modal.module.scss';

interface IModalProps extends PropsWithChildren {
  showModal: boolean;
  modalClassname?: string;
  modalBaseClassname?: string;
}

/**
 * @param props - The props for the component.
 * @param showModal - Indicates visibility of the modal.
 * @param modalClassname - custom class name for the modal container.
 * @param modalBaseClassname - custom class name for the base modal.
 * @returns A React component that displays an modal.
 */

const Modal: FC<IModalProps> = (props) => {
  const { children, showModal, modalBaseClassname, modalClassname } = props;

  return createPortal(
    <Fade in={showModal} timeout={250} unmountOnExit>
      <div className={[styles.modalLayout, modalClassname].join(' ')}>
        <div className={[styles.modalBase, modalBaseClassname].join(' ')}>
          {children}
        </div>
      </div>
    </Fade>,
    document?.getElementById('modalRoot')!
  );
};

export default Modal;
